import fetch from '../utils/fetch';

export function vrlist(params) {
  return fetch({
    method: 'GET',
    url: '/vr/list',
    params
  })
}

export function vrsave(params) {
  return fetch({
    method: 'POST',
    url: '/vr/save',
    data:params
  })
}
export function vrupdate(params) {
  return fetch({
    method: 'POST',
    url: '/vr/update',
    data:params
  })
}

export function vrdelete(params) {
  return fetch({
    method: 'POST',
    url: '/vr/delete',
    params
  })
}

export function projectAndBuild(params) {
  return fetch({
    method: 'GET',
    url: '/projectBasics/projectAndBuild',
    params
  })
}
export function forHouseType(params) {
  return fetch({
    method: 'GET',
    url: '/projectBasics/fuzzyroom/forHouseType',
    params
  })
}
export function getHouseTypeAndArea(params) {
  return fetch({
    method: 'GET',
    url: '/vr/getHouseTypeAndArea',
    params
  })
}
export function housetypeforProject(params) {
  return fetch({
    method: 'GET',
    url: '/housetype/forProject',
    params
  })
}


export function getVRState(params) {
  return fetch({
    method: 'GET',
    url: '/vr/getVRState',
    params
  })
}

export function forProjectAndBuild(params) {
  return fetch({
    method: 'GET',
    url: '/functionalarea/forProjectAndBuild',
    params
  })
}

export function getVrUrl(params) {
  return fetch({
    method: 'POST',
    url: '/vr/getVrUrl',
    params
  })
}
